import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { EpButton } from '../../../components/EpButton';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { userService } from '../../../services/userService';
import { useHospitalStore } from '../../../stores';
import { useTranslationStore } from '../../../stores/useTranslationStore';
import styles from '../EpStarter.module.scss';
import { StarterModal } from '../EpStarterModal';

/** @TODO - remover a linha abaixo quando resolver o problema de import no layout.tsx */
import '../../../internationalization/i18n';
import { usePathname } from 'next/navigation';
import { useQueryClient } from '@tanstack/react-query';
import { EpLoading } from '../../../components/EpLoading';
import { getDefaultAccess } from '../../../utils/defaultAccess';
import { EpimedLogoSVGCode } from '../../../components/EpHeaderNavigation/EpimedLogo';

const { getUserBundles } = userService;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LoggedOutHeader = ({ cultures }: { cultures: any }) => {
  const { i18n } = useTranslation();
  const { translations } = useTranslationStore((state) => state);
  const { hospitalInfo } = useHospitalStore((state) => state);
  const pathname = usePathname();
  const isPublicPath = pathname.includes('Public');
  const { data: hospitalLogo = '' } = userService.getHospitalLogoNotLogged(
    hospitalInfo ? hospitalInfo?.HospitalId : '',
    !!hospitalInfo?.HospitalId && isPublicPath,
  );
  const hospitalLogoUrl = hospitalLogo?.filePath ? hospitalLogo?.filePath : '';

  const defaultAccess = getDefaultAccess();
  
  const tenantId = hospitalInfo?.TenantId || defaultAccess?.tenantId;
  const networkId = hospitalInfo?.NetworkId || defaultAccess?.networkId;
  const hospitalId = hospitalInfo?.HospitalId || defaultAccess?.hospitalId;

  const bundleKey = ['userBundles', i18n.language, tenantId, networkId, hospitalId];
  const userBundles = useQueryClient().getQueryData(bundleKey);
  const { isFetching: isLoadingBundles } = getUserBundles({
    hospitalId: hospitalId,
    enabled: !!hospitalId && !userBundles,
    key: bundleKey
  });

  if (isLoadingBundles) {
    return (
      <EpLoading loadingId={'loading--page'} isVisible />
    );
  }

  return (
    <header className={clsx(styles['header'], styles['header--logout'])}>
      <div className={styles['header__options']}>
        <EpimedLogoSVGCode />

      </div>

      {hospitalLogo?.filePath && (
        <div className={styles['header__options']}>
          <img
            src={hospitalLogoUrl}
            style={{ height: 'auto', maxWidth: '200px' }}
            alt="Hospital Logo"
          />
        </div>
      )}

      <div className={styles['header__options']}>
        <EpButton
          buttonId="ep-modal__language--button"
          buttonSize="md"
          buttonType="link-primary"
          buttonDataBsTarget="#ep-modal__language"
          buttonDataBsToggle="modal"
          buttonLeftIconName="SolidGlobe"
          buttonText={t(translations['global'], 'Language ({0})').replace(
            '{0}',
            i18n.language,
          )}
        />

        {cultures && (
          <StarterModal
            cultures={cultures}
            handleLanguage={(value: string) => i18n.changeLanguage(value)}
            translations={translations['global']}
          />
        )}
      </div>
    </header>
  );
};
